import React from "react";
import ReactDOM from 'react-dom';
import "./index.css";
import App from "./App";
import { BrowserRouter, Routes, Route } from "react-router-dom";

const APP_PATH = process.env.REACT_APP_CONTEXT_PATH;
ReactDOM.render(
  <React.StrictMode>
  <BrowserRouter basename={`${APP_PATH}`}>
    <Routes>
      <Route path="/*" element={<App />} />
    </Routes>
  </BrowserRouter>
</React.StrictMode>,
  document.getElementById('root')
);